import React from "react";
import { TeslaImgPage } from "../../assets/images";
import { CommunityProps } from "../../types";
import { SkeletonElement, Shimmer } from "..";

type CommunityCardProps = {
  community: CommunityProps | undefined;
  loading: boolean | undefined;
};
const CommunityCard: React.FC<CommunityCardProps> = ({
  community,
  loading,
}) => {
  const MaxLength = 300;

  const [isExpanded, setIsExpanded] = React.useState(false);

  function capitalizeFirstLetter(str: any) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  }

  const longText = capitalizeFirstLetter(community?.description) || ""; // the empty string is there to avoid an undefine error.

  return (
    <>
      <div className="lg:flex lg:flex-row flex flex-col w-full bg-midGreen overflow-hidden lg:h-[247px] h-[289px] rounded pt-[56px]  shadow lg:justify-between lg:items-center text-start lg:pt-8">
        <div className="flex flex-col items-start lg:font-BRFirma font-Poppins pl-5 lg:pl-8">
          {loading && (
            <div className="relative overflow-hidden w-full">
              <SkeletonElement type="text" />
              <Shimmer />
            </div>
          )}
          <h1 className="lg:text-6xl text-[32px] text-[#FFFDFE] font-black">
            {!loading && community?.id && community?.name}
          </h1>
          <h1 className="lg:text-[23px] text-[16px] text-white font-medium">
            Community Page
          </h1>
        </div>
        <div className="flex lg:mt-9 justify-end">
          <img alt="" src={TeslaImgPage} className="h-[157px]" />
        </div>
      </div>

      <div className="w-full px-4 lg:px-0">
        <div className=" bg-midGreen flex items-center rounded-sm h-[38px] pl-[17px]">
          {loading && (
            <div className="relative overflow-hidden w-[60%]">
              <SkeletonElement type="title" />
              <Shimmer />
            </div>
          )}
          {!loading && (
            <h1 className="font-Poppins w-full text-start font-medium text-[12px] text-white gap-1">
              Community Created by
              <span className="font-bold w-full ml-1">
                {community?.id && community?.creator
                  ? `${community?.creator?.firstName}`
                  : community?.members && `${community?.members[0]?.firstName}`}
              </span>
            </h1>
          )}
        </div>
      </div>
      <div className="lg:hidden w-full px-4  rounded py-4 bg-white flex flex-col gap-1">
        <h5 className=" font-medium text-[9.2px] text-lightGreyText">ABOUT</h5>
        {loading && (
          <div className="relative overflow-hidden w-full">
            <SkeletonElement type="text" />
            <Shimmer />
          </div>
        )}
        {!loading &&
          (isExpanded ? (
            <p className="text-justify text-[10px] font-normal">{longText}</p>
          ) : (
            <p className="text-justify  text-[10px] font-normal ">
              {longText.length <= MaxLength
                ? longText
                : longText.slice(0, MaxLength) + "..."}

              {longText.length > MaxLength && (
                <span
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="cursor-pointer text-lightGreen"
                >
                  {isExpanded ? "See less" : "See more"}
                </span>
              )}
            </p>
          ))}
      </div>
    </>
  );
};

export default CommunityCard;
